/* tslint:disable */
/* eslint-disable */
/**
 * Vista API
 * Open API definition
 *
 * The version of the OpenAPI document: 1.36.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../../base';
// @ts-ignore
import { ReportIssueRequest } from '../../model/vista';
/**
 * ReportIssueApi - axios parameter creator
 * @export
 */
export const ReportIssueApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Returns the saved object
         * @summary saves issue details
         * @param {ReportIssueRequest} reportIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIssue: async (reportIssueRequest: ReportIssueRequest, options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'reportIssueRequest' is not null or undefined
            assertParamExists('reportIssue', 'reportIssueRequest', reportIssueRequest)
            const localVarPath = `/reportIssue`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication security_auth required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "security_auth", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(reportIssueRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * ReportIssueApi - functional programming interface
 * @export
 */
export const ReportIssueApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = ReportIssueApiAxiosParamCreator(configuration)
    return {
        /**
         * Returns the saved object
         * @summary saves issue details
         * @param {ReportIssueRequest} reportIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async reportIssue(reportIssueRequest: ReportIssueRequest, options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.reportIssue(reportIssueRequest, options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['ReportIssueApi.reportIssue']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * ReportIssueApi - factory interface
 * @export
 */
export const ReportIssueApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = ReportIssueApiFp(configuration)
    return {
        /**
         * Returns the saved object
         * @summary saves issue details
         * @param {ReportIssueRequest} reportIssueRequest 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        reportIssue(reportIssueRequest: ReportIssueRequest, options?: RawAxiosRequestConfig): AxiosPromise<string> {
            return localVarFp.reportIssue(reportIssueRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * ReportIssueApi - object-oriented interface
 * @export
 * @class ReportIssueApi
 * @extends {BaseAPI}
 */
export class ReportIssueApi extends BaseAPI {
    /**
     * Returns the saved object
     * @summary saves issue details
     * @param {ReportIssueRequest} reportIssueRequest 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof ReportIssueApi
     */
    public reportIssue(reportIssueRequest: ReportIssueRequest, options?: RawAxiosRequestConfig) {
        return ReportIssueApiFp(this.configuration).reportIssue(reportIssueRequest, options).then((request) => request(this.axios, this.basePath));
    }
}

